import { render, staticRenderFns } from "./TermsDashboard.vue?vue&type=template&id=1817e408&scoped=true&"
import script from "./TermsDashboard.vue?vue&type=script&lang=js&"
export * from "./TermsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TermsDashboard.vue?vue&type=style&index=0&id=1817e408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817e408",
  null
  
)

export default component.exports